module.exports = __webpack_public_path__ + "img/guardianWealth.5f9f190d.png";